import Sider from 'antd/es/layout/Sider';
import styled from 'styled-components';

export const CustomSider = styled(Sider)`
  position: fixed;
  right: 0;
  top: 0;

  height: 100vh;
  z-index: 50;
  width: 100vw !important;
  background: #153c7a;

  .close-button {
    position: absolute;
    font-size: 30px;

    height: 35px;
    width: 35px;

    top: 0;
    right: 5px;

    border: 0;
    background: transparent;
    color: white;

    .svg {
      fill: white;
      stroke: white;
      color: white;
    }

    &:focus {
      border: 0;
      outline: none;
    }
  }
`;

export const SiderItemsContainer = styled.div`
  width: 100%;

  padding: 25px 10%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 15px;

  .documents {
    display: flex;
    justify-content: flex-start;
    gap: 15px;
    color: white;
    flex-direction: column;

    ul {
      display: flex;
      flex-direction: column;
      gap: 10px;
      li {
        font-size: 18px;
        text-transform: uppercase;
        text-decoration: underline;
      }
    }

    .documents-layout {
      font-size: 24px;
      text-transform: uppercase;
    }
  }

  a,
  .auth {
    color: white;
    text-decoration: underline;
    text-transform: uppercase;
  }

  .auth {
    border: 0;
    background: transparent;
    text-align: left;

    &:focus {
      outline: none;
    }
  }

  .big {
    font-size: 24px;
    width: 320px;
  }

  .smaller,
  .auth {
    font-size: 20px;
    margin-left: 5px;
  }
`;
